import { useEffect, useRef, useState } from 'react';
import useDisplayClock from './useDisplayClock';

/**
 * useRise - a one-shot rise from 0 to 1 over `ms` (ease-out cubic), restarted whenever `key` changes: the
 * take-cover cue's screens growing out of the ground (2026-10-25, ~300 ms, then still). With `still` (the Motion
 * setting or the system asking for less) it is 1 at once, and no frame is ever asked for.
 *
 * @param {string} key - what the rise is OF: a new key rises again
 * @param {boolean} still
 * @param {number} [ms]
 * @returns {number} 0..1
 */
export default function useRise(key, still, ms = 300) {
  // The progress remembers the key it belongs to: a new key reads 0 on its FIRST render, not after the effect has
  // reset it - otherwise the new screens were painted fully risen for a frame, then dropped and rose (the review).
  const [rise, setRise] = useState({ key, t: still ? 1 : 0 });
  const start = useRef(0);
  useEffect(() => {
    start.current = window.performance.now();
    setRise({ key, t: still ? 1 : 0 });
  }, [key, still]);
  const t = rise.key === key ? rise.t : 0;
  const tick = (now) => setRise((r) => ({ key: r.key, t: Math.min(1, Math.max(0, (now - start.current) / ms)) }));
  useDisplayClock(!still && t < 1, tick);
  return still ? 1 : 1 - (1 - t) ** 3;
}
